// The branded 1200x630 card each money page shows when it is shared, and what
// Google Images has to go on for that page. One source of truth: the app reads
// it through useSocialMeta (og:image / twitter:image) and
// scripts/generate-sitemap.mjs reads it to write the <image:image> entries.
//
// The files themselves come from scripts/generate-og-images.mjs (`npm run og`).
// Keep a page's `alt` describing the card honestly — it is read aloud by screen
// readers and is the strongest text signal an image result has.

export const IMAGE_DIR = "/og";

export const PAGE_IMAGES = {
  "/ios-development": {
    file: "ios-app-development-india.png",
    alt: "iOS app development services in India: Swift apps from first build to App Store and maintenance",
  },
  "/android-development": {
    file: "android-app-development-india.png",
    alt: "Android app development services in India: Kotlin apps tested across real device and OS spread",
  },
  "/saas-development": {
    file: "saas-development-multi-tenant.png",
    alt: "SaaS development: multi-tenant architecture, billing and roles from first release to scale",
  },
  "/crm-development": {
    file: "custom-crm-development.png",
    alt: "Custom CRM software development built around an existing sales pipeline",
  },
  "/erp-services": {
    file: "custom-erp-development-integration.png",
    alt: "Custom ERP software development and integration with existing business systems",
  },
  "/qa-and-testing": {
    file: "software-testing-qa-services-india.png",
    alt: "Software testing and QA services: manual and automated testing for web, mobile and APIs",
  },
  "/software-integration-services": {
    file: "software-integration-services.png",
    alt: "Software integration services connecting existing business systems and legacy tools",
  },
  "/business-intelligence": {
    file: "business-intelligence-dashboards.png",
    alt: "Business intelligence services: data pipelines and dashboards with trustworthy numbers",
  },
  "/cloud-migration": {
    file: "cloud-migration-services.png",
    alt: "Cloud migration services: assessment, sequencing and rollback planning",
  },
  "/cloud-consulting": {
    file: "cloud-consulting-services-aws-azure.png",
    alt: "Cloud consulting services for AWS and Azure: architecture, cost and operations",
  },
  "/ci-cd-pipelines": {
    file: "ci-cd-pipeline-setup-automation.png",
    alt: "CI/CD pipeline setup and automation for repeatable builds, tests and deployments",
  },
  "/offshore-software-development": {
    file: "offshore-software-development-india.png",
    alt: "Offshore software development from India with overlapping hours and written decisions",
  },
  "/software-development-outsourcing": {
    file: "software-development-outsourcing-models.png",
    alt: "Software development outsourcing: fixed scope, dedicated team and staff augmentation compared",
  },
  "/software-consulting": {
    file: "software-consulting-architecture-scoping.png",
    alt: "Software consulting services: architecture, scoping, estimates and risk assessment",
  },
  "/user-research": {
    file: "ux-research-services.png",
    alt: "UX research services: user interviews, usability testing and research findings",
  },
  "/wireframing-prototyping": {
    file: "wireframing-prototyping-services.png",
    alt: "Wireframing and prototyping services: wireframes and clickable prototypes before build",
  },
  "/mobile-consulting": {
    file: "mobile-app-consulting-services.png",
    alt: "Mobile app consulting: choosing between native, Flutter and React Native",
  },
  "/mobile-first-design": {
    file: "mobile-first-web-design.png",
    alt: "Mobile-first web design: layouts designed at phone width first",
  },
  "/performance-optimization": {
    file: "website-performance-optimization.png",
    alt: "Website performance optimization driven by Core Web Vitals field data",
  },
  "/product-support-maintenance": {
    file: "software-maintenance-support.png",
    alt: "Software maintenance and support after launch: fixes, updates and monitoring",
  },
  "/support-maintenance": {
    file: "software-support-24-7.png",
    alt: "24/7 software support and maintenance with agreed response times",
  },
  "/updates-bug-fixes": {
    file: "software-bug-fixing-updates.png",
    alt: "Software bug fixing and updates with regression testing",
  },
  "/contact": {
    file: "contact-inqmise-technologies.png",
    alt: "Contact InQmise Technologies in Badarpur, New Delhi — reply within one business day",
  },
  "/case-studies": {
    file: "inqmise-case-studies.png",
    alt: "InQmise Technologies case studies: insurtech, construction escrow, fitness and AI projects",
  },
  "/case-studies/goal-envision": {
    file: "goal-envision-strategy-software-case-study.png",
    alt: "GoalEnvision case study: strategy execution software built on .NET Core and Azure",
  },
  "/our-core-team": {
    file: "inqmise-core-team.png",
    alt: "The InQmise Technologies core team: engineers, designers and support staff",
  },
  "/how-we-work-and-function": {
    file: "how-inqmise-works-seven-stages.png",
    alt: "InQmise’s software development process: seven stages from requirements discovery to launch and ongoing support",
  },
  "/faq": {
    file: "inqmise-faq.png",
    alt: "Frequently asked questions about working with InQmise Technologies",
  },
  "/career": {
    file: "careers-at-inqmise-technologies.png",
    alt: "Explore careers at InQmise Technologies in Delhi NCR and share your experience for future opportunities in software, design, cloud and AI",
  },
  "/": {
    file: "inqmise-technologies-software-company-india.png",
    alt: "InQmise Technologies: digital transformation with AI, automation and connected business systems",
  },
  "/about": {
    file: "about-inqmise-technologies-delhi-ncr.png",
    alt: "InQmise Technologies builds custom software, AI and cloud solutions around business goals, from Delhi NCR for local and international clients",
  },
  "/technologies": {
    file: "inqmise-technology-stack-react-dotnet-ai.png",
    alt: "InQmise technology stack: React, .NET, Node, Flutter, AWS, Azure and the AI tooling behind its builds",
  },
  "/big-data": {
    file: "big-data-services-india.png",
    alt: "Big data services in India: data pipelines, warehouse design and system integration",
  },
  "/data-analytics": {
    file: "data-analytics-services-india.png",
    alt: "Data analytics services: reporting and dashboards built around the decisions a team actually makes",
  },
  "/fintech-consulting": {
    file: "fintech-software-consulting-india.png",
    alt: "Fintech software consulting and development: payments, escrow and insurtech platforms",
  },
  "/case-studies/ezrater": {
    file: "ezrater-insurance-rating-case-study.png",
    alt: "EZRater case study: insurance quote comparison across 40+ carriers in 8 seconds",
  },
  "/case-studies/three-lock-box": {
    file: "three-lock-box-construction-escrow-case-study.png",
    alt: "Three Lock Box case study: construction escrow and payment control software for the US market",
  },
  "/case-studies/gym-chain-integration": {
    file: "gym-management-software-case-study.png",
    alt: "Gym management software integration case study: CRM, mobile app, QR gates and kiosk payments",
  },
  "/case-studies/ai-style-recommendation": {
    file: "ai-fashion-recommendation-engine-case-study.png",
    alt: "AI fashion recommendation engine case study: personalized style discovery for retail",
  },
  "/cloud-architecture-design": {
    file: "cloud-architecture-design-services.png",
    alt: "Cloud architecture design and consulting services for AWS and Azure",
  },
  "/cloud-native-applications": {
    file: "cloud-native-application-development.png",
    alt: "Cloud native application development: containers, managed services and CI/CD from day one",
  },
  "/cloud-infrastructure-automation": {
    file: "cloud-infrastructure-automation-iac.png",
    alt: "Cloud infrastructure automation and infrastructure-as-code services",
  },
  "/cloud-security-facet": {
    file: "cloud-security-services-aws-azure.png",
    alt: "Cloud security services: AWS and Azure hardening, identity, secrets and logging",
  },
  "/cybersecurity-compliance": {
    file: "application-security-compliance-services.png",
    alt: "Application security and compliance services built into the delivery process",
  },
  "/cybersecurity-consulting-services": {
    file: "cybersecurity-consulting-services-india.png",
    alt: "Cybersecurity consulting services in India: reviews, testing and remediation planning",
  },
  "/it-audit-services": {
    file: "it-audit-services-india.png",
    alt: "IT audit services in India: infrastructure, access and process audits",
  },
  "/legacy-system-modernization": {
    file: "legacy-application-modernization-services.png",
    alt: "Legacy application modernization services: incremental migration without a rewrite",
  },
  "/native-cross-platform-apps": {
    file: "cross-platform-app-development-flutter-react-native.png",
    alt: "Cross-platform app development with Flutter and React Native",
  },
  "/serverless-microservices": {
    file: "serverless-microservices-development.png",
    alt: "Serverless and microservices development services",
  },
  "/compliance-regulations": {
    file: "soc2-iso27001-gdpr-compliance-consulting.png",
    alt: "SOC 2, ISO 27001 and GDPR compliance consulting and engineering support",
  },
  "/digital-transformation-roadmap": {
    file: "digital-transformation-roadmap.png",
    alt: "Digital transformation roadmap: sequenced and costed steps for systems change",
  },
  "/mobile-performance-security": {
    file: "mobile-app-performance-security.png",
    alt: "Mobile app performance and security: startup time, crash rate and security review",
  },
  "/services": {
    file: "software-development-services-india.png",
    alt: "Software development services from InQmise Technologies: discovery, design, build, launch and support",
  },
  "/ai-solutions": {
    file: "ai-development-company-india.png",
    alt: "AI development company in India — agentic AI, LLM integration, RAG and recommendation engines",
  },
  "/agentic-ai-development": {
    file: "agentic-ai-development-services.png",
    alt: "Agentic AI development services: AI agents that plan, call your tools and hand work back to people",
  },
  "/llm-integration-services": {
    file: "llm-integration-rag-development.png",
    alt: "LLM integration and RAG development: answers from your own documents, with citations and access control",
  },
  "/generative-ai-development": {
    file: "generative-ai-development-services.png",
    alt: "Generative AI development services in India, from prototype to production with guardrails and monitoring",
  },
  "/ai-integration-services": {
    file: "ai-integration-services.png",
    alt: "AI integration services: AI built into the CRM, ERP, support desk and internal apps a business already uses",
  },
  "/recommendation-engine-development": {
    file: "recommendation-engine-development.png",
    alt: "Recommendation engine development for ecommerce and marketplaces, measured on revenue",
  },
  "/custom-software-development": {
    file: "custom-software-development-company-india.png",
    alt: "Custom software development company in India building platforms, internal tools and customer portals",
  },
  "/web-development": {
    file: "web-development-company-delhi-ncr.png",
    alt: "Web development company in Delhi NCR building React and .NET web applications",
  },
  "/mobile-app-development": {
    file: "mobile-app-development-company-india.png",
    alt: "Mobile app development company in India: native iOS and Android, Flutter and React Native",
  },
  "/ecommerce-development": {
    file: "ecommerce-website-development.png",
    alt: "Ecommerce website development with payment and logistics integrations, built to convert on mobile",
  },
  "/ui-ux-design": {
    file: "ui-ux-design-company-delhi-ncr.png",
    alt: "UI/UX design company in Delhi NCR: research, wireframes, prototypes and a buildable design system",
  },
  "/api-development": {
    file: "api-development-integration-services.png",
    alt: "API development and integration services: REST and GraphQL APIs, payment gateways and webhooks",
  },
  "/cloud-development": {
    file: "cloud-application-development-services.png",
    alt: "Cloud application development services on AWS and Azure, with serverless and microservices architecture",
  },
  "/devops-services": {
    file: "devops-services-company-india.png",
    alt: "DevOps services in India: CI/CD pipelines, infrastructure as code and monitoring",
  },
  "/security-audits-pen-testing": {
    file: "vapt-penetration-testing-services-india.png",
    alt: "VAPT and penetration testing services in India, with a fix plan developers can follow",
  },
  "/it-consulting": {
    file: "it-consulting-company-delhi-ncr.png",
    alt: "IT consulting company in Delhi NCR: architecture reviews, technology choices and delivery planning",
  },
  "/digital-transformation": {
    file: "digital-transformation-services-india.png",
    alt: "Digital transformation services in India: process mapping, system modernization and rollout planning",
  },
  "/managed-it-services": {
    file: "managed-it-services-delhi-ncr.png",
    alt: "Managed IT services in Delhi NCR: monitoring, patching, backups and support",
  },
  "/iot": {
    file: "iot-development-services-india.png",
    alt: "IoT development services in India: connected devices, gateways and fleet dashboards",
  },
  "/blockchain": {
    file: "blockchain-development-services-india.png",
    alt: "Blockchain development services in India: smart contracts, wallets and chain integrations",
  },
  "/products/cledge": {
    file: "cledge-clinic-management-software-india.png",
    alt: "Cledge clinic management software for Indian clinics: appointments, patient records, prescriptions and reminders",
  },
};

const DEFAULT_IMAGE = {
  file: "og-default.png",
  alt: "InQmise Technologies — AI and software development company in Delhi NCR, India",
  root: true,
};

/** The card for a route, falling back to the site-wide default. */
export function getPageImage(pathname) {
  const key = pathname !== "/" && pathname.endsWith("/") ? pathname.slice(0, -1) : pathname;
  const entry = PAGE_IMAGES[key];
  if (!entry) return { url: `/${DEFAULT_IMAGE.file}`, alt: DEFAULT_IMAGE.alt };
  return { url: `${IMAGE_DIR}/${entry.file}`, alt: entry.alt };
}
